import { render, staticRenderFns } from "./newBranchModal.vue?vue&type=template&id=674bcea0&"
import script from "./newBranchModal.vue?vue&type=script&lang=ts&"
export * from "./newBranchModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports